import * as Models from "../.";

export interface IRegion {
  regionId: number;
  utilityId: number;
  commonUtilityCode: string;
  name: string;
  active: boolean;
  utilityName: string;
  regionPricings: Models.CostCalculation.RegionPricing.IRegionPricing[];
  customerAdderGroupCode: string;
}

export class Region implements IRegion {
  public regionId: number;
  public utilityId: number;
  public commonUtilityCode: string;
  public name: string;
  public active: boolean;
  public utilityName: string;
  public regionPricings: Models.CostCalculation.RegionPricing.IRegionPricing[];
  public customerAdderGroupCode: string;

  constructor() {
    this.name = "New Region";
    this.active = true;
    this.regionPricings = [];
  }
}
